export const SERVICE_PRICING_OPTIONS = [
  {
    value: "FIXED",
    label: "Prix fixe",
    description: "Le client voit un montant ferme pour la prestation.",
  },
  {
    value: "STARTING_AT",
    label: "A partir de",
    description: "Le prix affiche une base puis le devis precise le total.",
  },
  {
    value: "QUOTE_ONLY",
    label: "Sur devis",
    description: "Le client contacte la boutique avant toute estimation.",
  },
] as const

export const SERVICE_DELIVERY_OPTIONS = [
  {
    value: "ONSITE",
    label: "Sur site",
    description: "La prestation se deroule chez le client ou sur un lieu physique.",
  },
  {
    value: "REMOTE",
    label: "A distance",
    description: "Le service peut etre livre en ligne ou par telephone.",
  },
  {
    value: "HYBRID",
    label: "Hybride",
    description: "La prestation combine presentiel et distance.",
  },
] as const
